import { render } from "./FormatNumber.vue?vue&type=template&id=40586884"
import script from "./FormatNumber.vue?vue&type=script&lang=js"
export * from "./FormatNumber.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__